
import {defineComponent} from "vue";
import {CodeDescriptionRestDto, MultilingualProductPropertyRestDto} from "@/api/pharma-cpc-product-mgmt/models";
import CustomerProductPropertiesItem
  from "@/components/layouts/catalog/customer-products/CustomerProductPropertiesItem.vue";
import {
  MultilingualProductPropertyRestDtoModel
} from "@/models/api/pharma-cpc-product-mgmt/MultilingualProductPropertyRestDtoModel";
import {
  MultilingualTextFieldRestDtoModel
} from "@/models/api/pharma-cpc-product-mgmt/MultilingualTextFieldRestDtoModel";
import {PRODUCT_PROPERTY_TYPE_CODES_ENUM} from "@/store/pharma-cpc-product-mgmt/middleware";
import {isValidMultilingualTextField} from "@/helpers/functions/multilingual";
import {PropType} from "vue/dist/vue";
import {
  CustomerProductWithImageDetailRestDtoModel
} from "@/models/api/pharma-cpc-product-mgmt/CustomerProductWithImageDetailRestDtoModel";
import { debounce } from 'lodash';

export default defineComponent({
  name: "CustomerProductProperties",
  components: {CustomerProductPropertiesItem},
  emits: ['update:modelValue'],
  data: () => ({
    productProperties: [] as MultilingualProductPropertyRestDto[],
    emitDebounceTimer: null as number | null,  // Add this
  }),
  mounted() {
  },
  watch: {
    modelValue: {
      handler(_newValue: CustomerProductWithImageDetailRestDtoModel) {
        this.reloadContent();
      },
      immediate: true,
    }
  },
  props: {
    modelValue: {
      type: Object as PropType<CustomerProductWithImageDetailRestDtoModel>,
      required: true
    },
    errors: {
      type: Object,
    },
  },
  methods: {
    async reloadContent(): Promise<void> {
      this.productProperties = [];
      // Add empty properties if not exists
      PRODUCT_PROPERTY_TYPE_CODES_ENUM.forEach((property_type: CodeDescriptionRestDto) => {
        const existingProp: MultilingualProductPropertyRestDto | undefined = this.modelValue.product.product_properties
          ?.find((product_property: MultilingualProductPropertyRestDto) => product_property.property_type_code === property_type.code) as MultilingualProductPropertyRestDto | undefined;
        if (existingProp) {
          this.productProperties.push(existingProp);
        } else {
          this.productProperties.push(new MultilingualProductPropertyRestDtoModel(
            property_type.code,
            MultilingualTextFieldRestDtoModel.createWithDefaults()));
        }
      });
    },
    emitNewValue: debounce(function(this: any) {
      const validProperties = [] as MultilingualProductPropertyRestDto[];
      this.productProperties.forEach((property: MultilingualProductPropertyRestDto) => {
        if (isValidMultilingualTextField(property.value)) {
          validProperties.push(property);
        }
      });
      this.$emit('update:modelValue', {
        ...this.modelValue,
        product: {
          ...this.modelValue.product,
          product_properties: validProperties
        }
      });
    }, 300)
  },
});
